module.exports = __webpack_public_path__ + "../resources/img/ic_tornado_weather.47202e94.svg";